import React from 'react';
import { Dropdown } from 'react-bootstrap';

export interface DarkSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface DarkSelectProps {
  value: string;
  options: DarkSelectOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  ariaLabel?: string;
}

const DarkSelect: React.FC<DarkSelectProps> = ({
  value,
  options,
  onChange,
  placeholder = '-- Select --',
  disabled,
  id,
  ariaLabel,
}) => {
  const selected = options.find((o) => o.value === value);
  const label = selected ? selected.label : placeholder;

  return (
    <Dropdown
      onSelect={(eventKey) => {
        if (eventKey !== null && eventKey !== undefined) onChange(eventKey);
      }}
    >
      <Dropdown.Toggle
        id={id}
        variant="secondary"
        disabled={disabled}
        aria-label={ariaLabel}
        className="dark-select-toggle w-100 d-flex justify-content-between align-items-center"
      >
        <span className={`dark-select-label ${selected ? '' : 'text-muted'}`} title={typeof label === 'string' ? label : undefined}>{label}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dark-select-menu w-100">
        {placeholder && (
          <Dropdown.Item eventKey="" active={value === ''}>
            <span className="text-muted">{placeholder}</span>
          </Dropdown.Item>
        )}
        {options.map((opt) => (
          <Dropdown.Item
            key={opt.value}
            eventKey={opt.value}
            active={opt.value === value}
            disabled={opt.disabled}
          >
            {opt.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DarkSelect;
